import React, { useEffect, useState } from 'react';
import { Alert, Button, Modal } from 'react-bootstrap';
import SimpleCheck from 'reusable/Check';
import SimpleText from 'reusable/Text';
import { SectionEditModalStyles } from './style';

function SectionEditModal({
  show,
  onHide,
  action,
  index,
  value,
  onSubmit,
  sections,
}) {
  const [editValue, setEditValue] = useState(value);

  useEffect(() => {
    setEditValue(value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show, index]);

  const errorMessages = () => {
    if (!editValue.name) return 'Name is Required';
    const nameIndex = sections.findIndex(section => section === editValue.name);
    if (nameIndex !== -1 && nameIndex !== index)
      return 'Section with given name already exists';
    return '';
  };

  return (
    <SectionEditModalStyles show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>
          {action === 'edit' ? 'Edit Section' : 'Add Section'}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <SimpleText
          label="Name"
          value={editValue.name || ''}
          onChange={value => setEditValue(prev => ({ ...prev, name: value }))}
        />
        <br />
        <SimpleCheck
          label="Visible"
          value={editValue.visible || false}
          onChange={value =>
            setEditValue(prev => ({ ...prev, visible: value }))
          }
        />
        {errorMessages() && <Alert variant="danger">{errorMessages()}</Alert>}
      </Modal.Body>
      <Modal.Footer>
        <Button
          onClick={() => {
            onSubmit(action, editValue, index);
            onHide();
          }}
          disabled={!!errorMessages()}
        >
          Save
        </Button>
        {action === 'add' ? null : (
          <Button
            variant="danger"
            onClick={() => {
              onSubmit('delete', editValue, index);
              onHide();
            }}
          >
            Delete
          </Button>
        )}
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </SectionEditModalStyles>
  );
}

export default SectionEditModal;
